import { css, cx } from '@onbeam/business-styled-system/css';
import { TimelineDotProps } from './TimelineDot.types';

export const TimelineDot = ({
  isActive,
  className,
  ...props
}: TimelineDotProps) => (
  <div
    aria-hidden
    data-active={isActive}
    className={cx(
      css({
        position: 'absolute',
        top: '[25%]',
        left: '[50%]',
        transform: 'translate(-50%, -50%)',
        rounded: 'full',
        h: '[0.75rem]',
        w: '[0.75rem]',
        bg: 'mono.quinary',
        zIndex: 5,
        transition: 'colors',
        transitionDuration: 'normal',

        _active: {
          bg: 'mono.primaryBg',
        },
      }),
      className,
    )}
    {...props}
  />
);
